import { bootstrapWidget } from "../../common";
import MultiCalendarWidget from "./widget";

bootstrapWidget({
  widget: MultiCalendarWidget,
  widgetType: "multi-calendar",
  // No cssUrls: the old override was just the defaults the mount resolver
  // already provides, but as a full override it displaced the SSR page's
  // hashed links with /w/ guesses (#787).
});
